import { makeAutoObservable } from 'mobx';
import guid from '../../../../utils/guid';
import { User } from '../../../../models';

export default class Annotation {
  id;
  date_created;
  text;
  time;
  person;

  constructor({
    id = guid(),
    date_created = new Date(),
    text = '',
    time,
    person = {}
  }) {
    this.id = id;
    this.date_created = date_created;
    this.text = text;
    this.time = time;
    this.person = new User(person);

    makeAutoObservable(this);
  }
}
